import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../Assets/Image/sidebar/e-logo.png";
import dash from "../../Assets/Image/sidebar/dashboard.png";
import dash1 from "../../Assets/Image/sidebar/dashboard1.png";
import Dialog from "../../Base-Component/Dialog/Dialog";
import {
  CirclePercent,
  Images,
  Languages,
  Link2,
  LinkIcon,
  ListTodo,
  ScrollText,
  Shirt,
  Speaker,
  SquareUser,
  Store,
  Target,
  UserPlus,
  Users,
  UsersRound,
  Wallpaper,
} from "lucide-react";
import Cookies from "js-cookie";
import { allowModuleApi } from "../../Services/ApiServices";
import toast from "react-hot-toast";

const SideMenu = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const roleData = JSON.parse(localStorage.getItem("e-learn-data"));

  const trigger = useRef(null);
  const sidebar = useRef(null);

  const [isLogOut, setIsLogOut] = useState(false);

  const storedSidebarExpanded = localStorage.getItem("sidebar-expanded");
  const [sidebarExpanded, setSidebarExpanded] = useState(
    storedSidebarExpanded === null ? false : storedSidebarExpanded === "true"
  );

  const menuItems = [
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: (active) => (
        <img src={active ? dash1 : dash} className="w-5" alt="dashboard" />
      ),
    },
    {
      path: "/users",
      name: "Users",
      icon: (active) => (
        <Users color={active ? "white" : "#4B4B4B"} size={20} />
      ),
    },
    {
      path: "/user-role",
      name: "User Role",
      icon: (active) => (
        <UserPlus color={active ? "white" : "#4B4B4B"} size={20} />
      ),
    },
    {
      path: "/sub-admin",
      name: "Sub Admin",
      icon: (active) => (
        <SquareUser color={active ? "white" : "#4B4B4B"} size={20} />
      ),
    },
    {
      path: "/brand",
      name: "Brand",
      icon: (active) => (
        <Images color={active ? "white" : "#4B4B4B"} size={20} />
      ),
      matchPaths: ["/brand", "/brand/category-details","/contact-info"],
    },
    {
      path: "/quiz",
      name: "Quiz",
      icon: (active) => (
        <ListTodo color={active ? "white" : "#4B4B4B"} size={20} />
      ),
      matchPaths: ["/quiz", "/quiz/question", "/question/add-questions"],
    },
    {
      path: "/web-link",
      name: "Web Link",
      icon: (active) => (
        <Link2 color={active ? "white" : "#4B4B4B"} size={20} />
      ),
    },
    {
      path: "/news",
      name: "News",
      icon: (active) => (
        <ScrollText color={active ? "white" : "#4B4B4B"} size={20} />
      ),
    },
    {
      path: "/language",
      name: "Language",
      icon: (active) => (
        <Languages color={active ? "white" : "#4B4B4B"} size={20} />
      ),
    },
    {
      path: "/campaign",
      name: "Campaign",
      icon: (active) => (
        <Target color={active ? "white" : "#4B4B4B"} size={20} />
      ),
      matchPaths: ["/campaign", "/add-campaign"],
    },
    {
      path: "/offers",
      name: "Offers",
      icon: (active) => (
        <CirclePercent color={active ? "white" : "#4B4B4B"} size={20} />
      ),
      matchPaths: ["/offers", "/offer-user"],
    },
    {
      path: "/store",
      name: "Store",
      icon: (active) => (
        <Store color={active ? "white" : "#4B4B4B"} size={20} />
      ),
    },
    {
      path: "/social-media",
      name: "Social Media",
      icon: (active) => (
        <LinkIcon color={active ? "white" : "#4B4B4B"} size={20} />
      ),
    },
    {
      path: "/information",
      name: "Information",
      icon: (active) => (
        <Wallpaper color={active ? "white" : "#4B4B4B"} size={20} />
      ),
    },
    {
      path: "/whats-new",
      name: "What's New",
      icon: (active) => (
        <ScrollText color={active ? "white" : "#4B4B4B"} size={20} />
      ),
    },
  ];

  const [adminData, setAdminData] = useState({});
  const [allowedModules, setAllowedModules] = useState([]);

  const handleModuleList = () => {
    const obj = {
      user_id: roleData.userId,
    };

    allowModuleApi(obj)
      .then((res) => {
        const module = res.data.data;
        setAllowedModules(module);
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Cookies.remove("e_learning_token");
        } else {
          toast.error(err?.response?.data?.message || "Something went wrong");
        }
      });
  };

  const isActive = (menuItem) => {
    if (menuItem.matchPaths) {
      return menuItem.matchPaths.some(
        (path) =>
          location.pathname === path || location.pathname.startsWith(path)
      );
    }
    return location.pathname === menuItem.path;
  };

  // Filter menu items based on permissions
  const getFilteredMenuItems = () => {
    if (!allowedModules.length) return menuItems; // Show all if no modules loaded

    return menuItems.filter((item) =>
      allowedModules.some((module) => module.modules.path_name === item.path)
    );
  };

  useEffect(() => {
    if (roleData && roleData.role === "sub_admin") {
      handleModuleList();
    }
  }, []);

  useEffect(() => {
    const admin = JSON.parse(localStorage.getItem("Admin"));
    if (admin) {
      setAdminData(admin);
    }
  }, []);

  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return;
      if (
        !sidebarOpen ||
        sidebar.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setSidebarOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  useEffect(() => {
    localStorage.setItem("sidebar-expanded", sidebarExpanded.toString());
    if (sidebarExpanded) {
      document.querySelector("body")?.classList.add("sidebar-expanded");
    } else {
      document.querySelector("body")?.classList.remove("sidebar-expanded");
    }
  }, [sidebarExpanded]);

  return (
    <>
      <aside
        ref={sidebar}
        className={`absolute left-0 top-0 z-99 flex h-screen w-67 flex-col overflow-y-hidden duration-300 ease-linear dark:bg-boxdark 2xl:static xl:static lg:static 2xl:translate-x-0 xl:translate-x-0 lg:translate-x-0 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
        style={{ backgroundColor: "#fff" }}
      >
        {/* <!-- SIDEBAR HEADER --> */}
        <div className="flex items-center justify-center">
          <div
            onClick={() => {
              navigate("");
            }}
            className="py-3 mt-[17px] ms-4"
          >
            <img src={logo} className="w-44 rounded-full" alt="" />
          </div>
          <div className="ms-8">
            <button
              ref={trigger}
              onClick={() => setSidebarOpen(!sidebarOpen)}
              aria-controls="sidebar"
              aria-expanded={sidebarOpen}
              className="lg:hidden block"
            >
              <svg
                className="fill-current"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 8.175H2.98748L9.36248 1.6875C9.69998 1.35 9.69998 0.825 9.36248 0.4875C9.02498 0.15 8.49998 0.15 8.16248 0.4875L0.399976 8.3625C0.0624756 8.7 0.0624756 9.225 0.399976 9.5625L8.16248 17.4375C8.31248 17.5875 8.53748 17.7 8.76248 17.7C8.98748 17.7 9.17498 17.625 9.36248 17.475C9.69998 17.1375 9.69998 16.6125 9.36248 16.275L3.02498 9.8625H19C19.45 9.8625 19.825 9.4875 19.825 9.0375C19.825 8.55 19.45 8.175 19 8.175Z"
                  fill=""
                />
              </svg>
            </button>
          </div>
        </div>
        {/* <!-- SIDEBAR HEADER --> */}

        <div className="no-scrollbar flex flex-col justify-between overflow-y-auto duration-300 ease-linear h-full px-4 py-3">
          <div className="flex justify-start">
            <div>
              {getFilteredMenuItems().map((item) => {
                const active = isActive(item);
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                  >
                    <span
                      className={`flex items-center w-48 py-2 px-4 my-3.5 ${
                        active ? "bg-[#e29c29] rounded-xl" : ""
                      }`}
                    >
                      {item.icon(active)}
                      <h4
                        className={`ms-3 fontNew font-medium ${
                          active ? "text-white" : "text-[#4B4B4B]"
                        }`}
                      >
                        {item.name}
                      </h4>
                    </span>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </aside>

      <Dialog open={isLogOut} onClose={() => setIsLogOut(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Log Out?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you certain you wish to proceed with <br /> logging out?
                </p>
                <div className="flex mt-13 mb-5">
                  <button
                    className="bg-[#F4F5FA] py-[14px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsLogOut(false)}
                  >
                    Close
                  </button>
                  <button
                    className="bg-[#e29c29] py-[14px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={() => {
                      navigate("");
                    }}
                  >
                    Yes, Log Out
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </>
  );
};

export default SideMenu;
